export default __webpack_public_path__ + "assets/images/2.6eb80e.avif";